import { render, staticRenderFns } from "./ComplianceElementsWithNoLocations.vue?vue&type=template&id=2c7164ce&"
import script from "./ComplianceElementsWithNoLocations.vue?vue&type=script&lang=ts&"
export * from "./ComplianceElementsWithNoLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports